import moment from 'moment';

// NOTE The variable names here are a bit weird. If `isValid` is true,
// it returns a falsy value. If it is false i.e. if there's an error,
// it returns an error string.

export const isRequired = value => (value ? undefined : 'Required');

export const isSelectWithCountRequired = array => {
  const isValid = array && array.every(value => value.id && value.itemCount);
  return isValid ? undefined : 'Required';
};

export const isTimeInThePast = time => {
  const mTime = moment(time, 'HH:mm');
  const now = moment(new Date());
  return mTime.isBefore(now) ? 'Aika ei saa olla menneisyydessä' : undefined;
};

export const isDateTimeInThePast = dateTime => {
  if (moment(dateTime).isBefore(moment())) {
    return 'Aika ei saa olla menneisyydessä';
  }
  return null;
};

export const isValidDate = date => {
  return moment(date).isValid() ? null : 'Päivämäärä ei ole oikeassa muodossa';
};

export const isNumber = str => {
  if (typeof str !== 'string') return 'Vääränmuotoinen luku';
  return !isNaN(str) && !isNaN(parseFloat(str))
    ? null
    : 'Tarkista, ettei luvussa ole välilyöntejä tai muita virheellisiä merkkejä.';
};

export const isPhoneNumberValid = str => {
  if (!str) {
    return 'Tarkista puhelinnumero';
  }

  const regex = /^\+?[0-9\s-]+$/;
  const len = str.trim().length;

  if (len < 2) {
    return 'Tarkista puhelinnumero';
  }

  if (!regex.test(str)) {
    return 'Tarkista puhelinnumeron muoto. Sallitut merkit ovat +, -, välilyönti ja numerot.';
  }

  return null;
};

// Formik thinks key value pairs with null values are errors, so we have to
// delete them
export const removeEmptyKeys = obj => {
  // eslint-disable-next-line no-unused-vars
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
};
